import serviceBase from '../../../Services/serviceBase'

class MarketingSectionOptionsActions {
  getCountries = async () => {
    let url = `${window._env_.COMMUNITY_API_URL}/data/countries`
    return serviceBase.get(url).then(
      (response) => {
        let countries = [
          {
            value: 0,
            text: 'Select'
          }
        ]
        if (response.data) {
          response.data.forEach((element) => {
            countries.push({
              value: element.countryId,
              text: element.name
            })
          })
        }
        return countries
      },
      (err) => { }
    )
  }
  getStates = async (countryId) => {
    let url = `${window._env_.COMMUNITY_API_URL}/fire-departments/states-by-countryId`
    return serviceBase.post(url, { countryId }).then(
      (response) => {
        let states = [
          {
            value: 0,
            text: 'Select'
          }
        ]
        if (response.data) {
          response.data.forEach((element) => {
            if (element.length > 0) {
              states.push({
                value: element,
                text: element
              })
            }
          })
        }

        return states
      },
      (err) => { }
    )
  }
  getCounties = async (countryId, state) => {
    let url = `${window._env_.COMMUNITY_API_URL}/fire-departments/counties-by-countryId-and-state`
    return serviceBase.post(url, { countryId, state }).then(
      (response) => {
        let counties = [
          {
            value: 0,
            text: 'Select'
          }
        ]
        if (response.data) {
          response.data.forEach((element) => {
            counties.push({
              value: element,
              text: element
            })
          })
        }

        return counties
      },
      (err) => { }
    )
  }

  getAllEmergencyProvider = async () => {
    let url = `${window._env_.COMMUNITY_API_URL}/fire-departments/community-app-and-mcs-enabled`
    return serviceBase.get(url).then(
      (response) => {
        let emergencyProvider = []
        if (response.data && response.data.data) {
          response.data.data.forEach((element) => {
            emergencyProvider.push({
              value: element.identifier,
              text: element.fireDepartmentName
            })
          })
        }
        return emergencyProvider
      },
      (err) => { }
    )
  }
}

const marketingSectionOptionsActions = new MarketingSectionOptionsActions()

export default marketingSectionOptionsActions
